/* PostHog analytics for divyne.com (Jamie, 23 Oct 2026). snippets/divyne-analytics.liquid loads this file deferred
   (it runs when the page is parsed) and puts the page's own properties in window.dvAnalytics.page.
   - Visitors on an unpublished theme (previews), and anyone who has opened a page with ?dv_internal=1 (undo with
     ?dv_internal=0), carry is_internal: true. The PostHog project filters them out of results.
   - Every tap PostHog captures carries `area` (the page section it was in) and, on the controls that matter, `ui`
     (tier-3, add-to-cart-bar, cart-qty-to-2, chat-line and so on). Both are set at tap time, so the cart's
     re-rendered rows are named too. Copied text is captured as well.
   - What she saw: section_viewed fires once per section or key element after a second in view; the page's
     $pageleave carries the order she saw them in (`seen`), seconds in view (`seen_seconds`), how often she left the
     tab and for how long, and whether she pinch-zoomed.
   - Events autocapture can't see: gallery_photo (the furthest photo she reached), why_compare_used, dialog_opened /
     dialog_closed (gift sheets, the course sheet, the menu, with seconds open), video_play, pinch_zoom, and
     discount_code_tried (the code typed in the cart and whether the cart took it).
   - Split tests: $feature/<key> on every event and a $feature_flag_called exposure when the tested element is on screen. */
(function () {
  if (window.posthog && window.posthog.__loaded) return;
  var cfg = window.dvAnalytics || { page: {} };
  var page = cfg.page || {};

  try {
    if (/[?&]dv_internal=1\b/.test(location.search)) localStorage.setItem('dv_internal', '1');
    if (/[?&]dv_internal=0\b/.test(location.search)) localStorage.removeItem('dv_internal');
  } catch (e) {}
  var role = (window.Shopify && Shopify.theme && Shopify.theme.role) || '';
  var flagged = false;
  try { flagged = localStorage.getItem('dv_internal') === '1'; } catch (e) {}

  /* ---- What she saw, kept for this page and added to its $pageleave. ---- */
  var seen = [], seenMs = {}, hiddenCount = 0, hiddenMs = 0, hiddenAt = 0, zoomed = false;
  var leaveProps = function () {
    var secs = {};
    for (var k in seenMs) secs[k] = Math.round(seenMs[k] / 100) / 10;
    return {
      seen: seen.slice(), seen_seconds: secs, tab_hidden_count: hiddenCount,
      tab_hidden_seconds: Math.round((hiddenMs + (hiddenAt ? Date.now() - hiddenAt : 0)) / 1000), pinch_zoomed: zoomed
    };
  };

  /* PostHog's loader stub, as the project's snippet gives it. */
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  /* Split tests (snippets/divyne-tests.liquid): a new visitor's PostHog id is her dv_vid, so assignment, storefront and
     checkout pixel share one id. */
  var tests = (window.dvTests && window.dvTests.tests) || {};
  var hasPH = false;
  try { hasPH = !!localStorage.getItem('ph_phc_qxBbDez796yn9S2hqJPdNdPcaYRhwQnentiMEisjShBp_posthog'); } catch (e) {}
  if (!hasPH) hasPH = document.cookie.indexOf('ph_phc_qxBbDez796yn9S2hqJPdNdPcaYRhwQnentiMEisjShBp_posthog=') > -1;

  posthog.init('phc_qxBbDez796yn9S2hqJPdNdPcaYRhwQnentiMEisjShBp', {
    bootstrap: !hasPH && window.dvTests && window.dvTests.vid ? { distinctID: window.dvTests.vid } : undefined,
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-08-30',
    person_profiles: 'identified_only',
    autocapture: { capture_copied_text: true },
    enable_heatmaps: true,
    capture_dead_clicks: true,
    capture_exceptions: true,
    capture_performance: { web_vitals: true },
    // Below 990 px the document scrolls; above it, Horizon's .page-wrapper does (divyne-ds.css, "Top of the page").
    scroll_root_selector: window.matchMedia('(min-width: 990px)').matches ? '.page-wrapper' : undefined,
    before_send: function (ev) {
      if (ev && ev.properties && ev.event !== '$snapshot') {
        for (var k in page) if (page[k] !== '') ev.properties[k] = page[k];
        if (ev.event === '$pageleave') { tick(); var l = leaveProps(); for (var j in l) ev.properties[j] = l[j]; }
      }
      return ev;
    }
  });
  posthog.register({ theme_role: role, is_internal: role !== 'main' || flagged });
  // Every event carries the variant of each running test ($feature/<key>), PostHog's experiment convention.
  var testProps = {};
  for (var tk in tests) testProps['$feature/' + tk] = tests[tk].variant;
  if (tk) posthog.register(testProps);

  /* ---- Sections and key elements. A section is named by its key in the template (main, why, proof, faq, also,
     hero, problems...); page_type tells product `main` from collection `main`. ---- */
  var sectionName = function (el) {
    var s = el && el.closest && el.closest('[id^="shopify-section-"]');
    if (!s) return '';
    var id = s.id.replace(/^shopify-section-/, '');
    return id.indexOf('__') > -1 ? id.split('__').pop() : id.replace(/^divyne-ds-/, '');
  };
  var ELEMENTS = [
    ['.dv-bar', 'campaign-bar'], ['dv-gallery', 'gallery'], ['.dv-title', 'title'], ['dv-tiers', 'tiers'],
    ['.dvp-box [data-dv-add]', 'add-button'], ['.dv-gifts', 'gifts'], ['.dv-buybar', 'buybar'],
    ['dv-details', 'details'], ['dv-compare', 'why-compare'], ['.dv-why-box', 'why-reasons'], ['.dv-reviews', 'reviews'],
    ['.dv-faq', 'faq'], ['.dv-also', 'also-like'], ['.dv-ask', 'ask'], ['.dv-tiles', 'problem-tiles'],
    ['.dv-clines', 'cart-lines'], ['.dv-cart-side', 'cart-summary'], ['dv-cart-timer', 'cart-timer'],
    ['.dv-checkout', 'checkout-button'], ['.dv-code', 'code-box']
  ];
  var targets = function () {
    var out = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (s) {
      var n = sectionName(s);
      if (n && n !== 'header') out.push(['section', n, s]);
    });
    ELEMENTS.forEach(function (e) {
      var els = document.querySelectorAll(e[0]);
      for (var i = 0; i < els.length; i++) {
        if (!els[i].getClientRects().length) continue; // hidden: the other title variant, a closed bar
        if (e[1] === 'details' && els[i].closest('.dv-faq')) continue; // the FAQ's own rows
        out.push(['element', e[1], els[i]]);
        break;
      }
    });
    return out;
  };
  var visibleSince = {}, sent = {};
  var exposed = {};
  var tick = function () {
    if (document.visibilityState === 'hidden') return;
    var vh = window.innerHeight, now = Date.now();
    // Split-test exposure: once per page, when the tested element is at least half on screen.
    for (var key in tests) {
      if (exposed[key] || !tests[key].exposure) continue;
      var el = document.querySelector(tests[key].exposure), r0 = el && el.getBoundingClientRect();
      if (!r0 || !r0.height) continue;
      if (Math.max(0, Math.min(r0.bottom, vh) - Math.max(r0.top, 0)) >= 0.5 * Math.min(r0.height, vh)) {
        exposed[key] = true;
        posthog.capture('$feature_flag_called', { $feature_flag: key, $feature_flag_response: tests[key].variant, dv_test_forced: tests[key].forced });
      }
    }
    targets().forEach(function (t) {
      var key = t[1], r = t[2].getBoundingClientRect();
      var h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      var inView = r.height > 0 && r.width > 0 && (h >= 0.5 * r.height || h >= 0.5 * vh);
      if (inView) {
        if (!visibleSince[key]) visibleSince[key] = now;
        var ms = now - visibleSince[key];
        if (ms >= 1000 && !sent[key]) {
          sent[key] = true;
          seen.push(key);
          posthog.capture('section_viewed', { section: key, kind: t[0], nth: seen.length, at_seconds: Math.round(performance.now() / 100) / 10 });
        }
        seenMs[key] = (seenMs[key] || 0) + (now - (visibleSince[key + ':last'] || visibleSince[key]));
        visibleSince[key + ':last'] = now;
      } else if (visibleSince[key]) {
        delete visibleSince[key]; delete visibleSince[key + ':last'];
      }
    });
  };
  setInterval(tick, 500);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      tick(); hiddenCount += 1; hiddenAt = Date.now(); visibleSince = {};
    } else if (hiddenAt) {
      hiddenMs += Date.now() - hiddenAt; hiddenAt = 0;
    }
  });

  /* ---- Readable names for the controls that matter. First match wins, so the specific rules come first. ---- */
  var nth = function (el, sel, scope) {
    var box = el.closest(scope);
    return box ? [].indexOf.call(box.querySelectorAll(sel), el) + 1 : 0;
  };
  var RULES = [
    ['dv-tiers .dv-seg-opt', function (el) { var i = el.querySelector('input'); return 'tier-' + (i && i.dataset.qty ? i.dataset.qty : nth(el, '.dv-seg-opt', 'dv-tiers')); }],
    ['.dv-sheet [data-dv-add]', 'add-to-cart-sheet'],
    ['.dv-buybar [data-dv-add]', 'add-to-cart-bar'],
    ['[data-dv-add]', 'add-to-cart'],
    ['[data-dv-open-sheet]', 'buybar-open-sheet'],
    ['[data-dv-close-sheet]', 'sheet-close'],
    ['dv-gallery', 'gallery'],
    ['dv-compare', 'why-compare'],
    ['.dv-faq .dv-details-q', function (el) { return 'faq-' + nth(el, '.dv-details-q', 'dv-details'); }],
    ['.dv-details-q', function (el) { return 'details-' + nth(el, '.dv-details-q', 'dv-details'); }],
    ['[data-dv-gifts-open]', 'gifts-open'],
    ['.dv-cline-rm', 'cart-remove'],
    ['.dv-cline [data-dv-qty]', function (el) { return 'cart-qty-to-' + el.dataset.dvQty; }],
    ['[data-dv-code-remove]', 'code-remove'],
    ['[data-dv-code-apply]', 'code-apply'],
    ['.dv-code summary', 'code-open'],
    ['[data-dv-checkout], .dv-checkout button', 'checkout'],
    ['a[href*="line.me"], a[href*="lin.ee"]', 'chat-line'],
    ['a[href*="m.me/"], a[href*="messenger.com"]', 'chat-messenger'],
    ['.dv-also .dv-pcard', 'also-like-card'],
    ['.dv-pcard', 'product-card'],
    ['.dv-hnav-tiles a, .dv-menu-tiles a', 'menu-tile'],
    ['[data-dv-menu-open]', 'menu-open'],
    ['.dv-bar-open, .dv-bar-in', 'campaign-bar'],
    ['.dv-reviews button, .dv-reviews a', 'reviews']
  ];
  var nameIt = function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var area = sectionName(t);
    if (area) t.setAttribute('data-ph-capture-attribute-area', area);
    for (var i = 0; i < RULES.length; i++) {
      var el = t.closest(RULES[i][0]);
      if (el) {
        var n = typeof RULES[i][1] === 'function' ? RULES[i][1](el) : RULES[i][1];
        el.setAttribute('data-ph-capture-attribute-ui', n);
        return;
      }
    }
  };
  // Window, capture phase: runs before PostHog's own listeners on the document.
  ['click', 'change', 'submit'].forEach(function (type) { window.addEventListener(type, nameIt, true); });

  /* ---- Gallery: the furthest photo reached, once per photo. dv-gallery keeps its current index in `cur`. ---- */
  var furthest = 0;
  var galleryMoved = function (e) {
    var g = e.target && e.target.closest && e.target.closest('dv-gallery');
    if (!g) return;
    setTimeout(function () {
      var n = (g.cur || 0) + 1;
      if (n > furthest) {
        furthest = n;
        if (n > 1) posthog.capture('gallery_photo', { photo: n, of: g.slides ? g.slides.length : null });
      }
    }, 60);
  };
  ['pointerup', 'click', 'keydown'].forEach(function (type) { document.addEventListener(type, galleryMoved, true); });

  /* ---- Why it works: the drag-to-compare, once per page. ---- */
  var compared = false;
  document.addEventListener('pointerdown', function (e) {
    if (compared || !e.target.closest || !e.target.closest('dv-compare')) return;
    compared = true;
    posthog.capture('why_compare_used');
  }, true);

  /* ---- Dialogs: gift sheets, the course sheet, the menu. Opened and closed, with seconds open. ---- */
  var dialogName = function (d) {
    if (d.classList.contains('dv-gift-sheet')) return /^dv-gifts-bar/.test(d.id) ? 'gift-sheet-bar' : 'gift-sheet';
    if (d.classList.contains('dv-drawer')) return 'menu';
    if (d.classList.contains('dv-sheet')) return 'course-sheet';
    return d.id || d.className.split(' ')[0] || 'dialog';
  };
  var openedAt = new WeakMap();
  new MutationObserver(function (list) {
    list.forEach(function (m) {
      var d = m.target;
      if (d.tagName !== 'DIALOG') return;
      if (d.open && !openedAt.has(d)) {
        openedAt.set(d, Date.now());
        posthog.capture('dialog_opened', { dialog: dialogName(d), area: sectionName(d) });
      } else if (!d.open && openedAt.has(d)) {
        posthog.capture('dialog_closed', { dialog: dialogName(d), seconds: Math.round((Date.now() - openedAt.get(d)) / 100) / 10 });
        openedAt.delete(d);
      }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });

  /* ---- Videos played, once each. ---- */
  var played = {};
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') return;
    var src = (v.currentSrc || v.src || '').split('?')[0].split('/').pop();
    if (played[src]) return;
    played[src] = true;
    posthog.capture('video_play', { video: src, area: sectionName(v) });
  }, true);

  /* ---- Discount codes typed in the cart: the code and whether the cart took it. dv-cart replaces its markup when the
     request returns, then shows the code as a chip (accepted) or the error line (rejected), so the result is read once
     the input she typed in has been replaced. ---- */
  var watchCode = function () {
    var input = document.querySelector('.dv-code-input');
    var code = input && input.value.trim();
    if (!code) return;
    var t0 = Date.now(), want = code.toLowerCase();
    var poll = setInterval(function () {
      var replaced = !input.isConnected, late = Date.now() - t0 > 8000;
      if (!replaced && !late) return;
      clearInterval(poll);
      setTimeout(function () {
        var chip = [].some.call(document.querySelectorAll('.dv-code-chip'), function (c) { return (c.dataset.code || '').toLowerCase() === want; });
        var err = document.querySelector('[data-dv-error]');
        var result = chip ? 'accepted' : (err && !err.hidden && err.textContent.trim()) ? 'rejected' : replaced ? 'unclear' : 'no response';
        posthog.capture('discount_code_tried', { code: code.toUpperCase().slice(0, 24), result: result, seconds: Math.round((Date.now() - t0) / 100) / 10 });
      }, 150);
    }, 200);
  };
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-dv-code-apply]')) watchCode(); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches && e.target.matches('.dv-code-input')) watchCode(); }, true);

  /* ---- Pinch zoom, once per page, with the section in the middle of the screen. ---- */
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      if (zoomed || window.visualViewport.scale < 1.15) return;
      zoomed = true;
      var mid = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2);
      posthog.capture('pinch_zoom', { area: sectionName(mid) });
    });
  }
})();
